import Fetch from '@/api';

// 活动
const state = {
  init: false,
  activityId: '',
  status: '', // 0-下架，1-上架 字符串
  name: '',
  resourcePutObj: {}
};

const mutations = {
  SET_ACTIVITY_INFO(state, { activityInfo }) {
    if (activityInfo) {
      state.init = true;
      state.activityId = activityInfo.activityId;
      state.status = activityInfo.status;
      state.name = activityInfo.name;
    }
  },
  SET_ACTIVITY_STATUS(state, status) {
    state.status = status;
  },
  SET_RESOURCE_PUT_OBJ(state, data) {
    state.resourcePutObj = data;
  }
};

const actions = {
  // 第一期活动，后续通过投放中心实现
  async initActivity({ commit }) {
    const res = await Fetch.get_current_matched_activity({});
    // const res = await Fetch.get_activity_by_id({ activityId: '2020060301' });
    commit('SET_ACTIVITY_INFO', res);
  },
  // 投放中心配置
  async getResourcePut({ commit }) {
    const res = await Fetch.resource_put_list();
    const resourcePutObj = res.reduce((obj, value) => {
      obj[value.resourceType] = value.resourcePutList;
      return obj;
    }, {});
    console.log('resourcePutObj', resourcePutObj);
    commit('SET_RESOURCE_PUT_OBJ', resourcePutObj);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
